// Surfaces an error to the user as a snackbar (see views/ErrorEventListener).
// This is purely a UI channel; Rollbar reporting is independent of it.
export default function showError(error) {
  window.dispatchEvent(new CustomEvent("fmserror", { detail: { error } }));
}
